'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../webComponents/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[BusSelect]');

var BusSelect = function () {
    function BusSelect($q, $scope, busService, departureService, cancelService, localizationService) {
        _classCallCheck(this, BusSelect);

        this.$q = $q;
        this.$scope = $scope;
        this.busService = busService;
        this.departureService = departureService;
        this.cancelService = cancelService;
        this.localizationService = localizationService;

        this.locale = {
            'fi': {
                'no_transport': 'Ei kuljetusta',
                'no_matches': 'Ei tuloksia',
                'loading': 'Ladataan',
                'input_too_short': 'Syötä vähintään 3 merkkiä',
                'select_bus_stop': 'Valitse pysäkki'
            },
            'en': {
                'no_transport': 'No transport',
                'no_matches': 'No matches',
                'loading': 'Loading',
                'input_too_short': 'Input is too short',
                'select_bus_stop': 'Select stop'
            }
        };

        this.placeholder = this.translate('select_bus_stop');

        this.noTransportAllowedCache = {};
    }

    // Angular select2 has issues with i18next
    // Use this function instead of i18next


    _createClass(BusSelect, [{
        key: 'translate',
        value: function translate(word) {
            var LANG = this.localizationService.getLanguage();
            return this.locale[LANG][word];
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.queryOptions = {
                formatNoMatches: this.translate('no_matches'),
                formatSearching: this.translate('loading'),
                formatInputTooShort: this.translate('input_too_short'),
                //minimumInputLength: 3,
                allowClear: true,
                query: function query(_query) {
                    return _this.queryStops(_query.term, _query.callback);
                }
            };

            this.$scope.$watch(function () {
                return _this.depDestIntClassSets;
            }, function () {
                return _this.checkAndPossiblyChangeStop();
            });
        }
    }, {
        key: 'checkAndPossiblyChangeStop',
        value: function checkAndPossiblyChangeStop() {
            var _this2 = this;

            var hasChoice = !(this.ngModel === undefined || this.ngModel === null);
            this.queryStops('', function (data) {
                var ok = data && data.results && data.results.length >= 0;
                if (!ok) {
                    // Data is not valid. Not sure what to do. Do nothing.
                    console.warn('Invalid stop query data:', data);
                } else if (hasChoice && _.some(data.results, function (x) {
                    return x.id === _this2.ngModel;
                })) {
                    // Currenct choice exists among the new options. Do nothing.
                } else {
                    // There is no current choice, or the choice is not among the new options.
                    var onlyNone = data.results.length === 1 && data.results[0].id === 0;
                    if (onlyNone) {
                        // The only option available is "no transport". Select it.
                        _this2.ngModel = 0;
                    } else {
                        // There are multiple options available. Make the user choose again.
                        _this2.ngModel = null;
                    }
                }
            }, true);
        }
    }, {
        key: 'queryStops',
        value: function queryStops(term, callback, noCancel) {
            var _this3 = this;

            // Clear before search
            // query.callback({results:[]});

            // No transport
            var data = {
                results: [{
                    id: 0,
                    text: this.translate('no_transport')
                }]
            };

            // Cache
            callback(this.data || data);

            if (!noCancel && this.pending) {
                this.cancelService.cancel(this.pending);
            }

            var depDestCode = this.depDestCode || undefined;
            var depBeginDate = this.depBeginDate || undefined;
            var depEndDate = this.depEndDate || undefined;
            var depDestIntClassSets = this.depDestIntClassSets || undefined;

            if (!term) {
                term = '';
            }

            var promises = {
                stops: this.busService.busStopsAutocomplete(term, depDestCode, depBeginDate, depEndDate, depDestIntClassSets),
                noTransportAllowed: this.$q.resolve(true)
            };

            // If we have a full departure, check if that departure is available without transport.
            // If transport is required, remove the "No transport" option.
            var NO_STOP = 0;
            if (_.some(data.results, function (r) {
                return r.id === NO_STOP;
            }) && depDestCode && depBeginDate && depEndDate) {
                var cacheKey = depDestCode + '-' + depBeginDate + '-' + depEndDate;
                var cached = _.has(this.noTransportAllowedCache, cacheKey);
                if (!cached) {
                    this.noTransportAllowedCache[cacheKey] = checkIfBookableWithoutTransport(this.departureService, depDestCode, depBeginDate, depEndDate, NO_STOP);
                }
                promises.noTransportAllowed = this.noTransportAllowedCache[cacheKey];
            }

            var request = this.$q.all(promises);

            if (!noCancel) {
                // Only cancel the stops part. The departure part will go to cache and be useful anyway.
                this.pending = promises.stops;
            }

            request.then(function (replies) {
                var busStops = replies && replies.stops;
                if (busStops && busStops.length >= 0) {
                    // The list can be empty!
                    // Map bus stops for select2
                    var busData = _.map(busStops, function (busStop) {
                        return {
                            id: busStop.Id,
                            text: busStop.Name
                        };
                    });

                    data.results = _.concat(data.results, busData);

                    if (replies.noTransportAllowed === false) {
                        // log('Removing the "No transport" option.');
                        _.remove(data.results, function (r) {
                            return r.id === NO_STOP;
                        });
                    }

                    var dataStr = JSON.stringify(data);
                    var oldDataStr = _this3.data ? JSON.stringify(_this3.data) : '';

                    // Cached data is identical
                    if (oldDataStr != dataStr) {
                        // Update select2 results
                        callback(data);
                    }

                    // Cache
                    _this3.data = data;
                }
            });
        }
    }]);

    return BusSelect;
}();

function checkIfBookableWithoutTransport(departureService, depDestCode, depBeginDate, depEndDate, noStop) {
    log('Checking if', depDestCode, depBeginDate, depEndDate, 'is bookable without transport...');
    return departureService.checkDeparture(depDestCode, depBeginDate, depEndDate, noStop).then(function (blockers) {
        if (blockers === null) {
            // Canceled. Should not be done to this promise!
            log.error('The departure check promise was canceled. It should not be, since the result goes to cache. Falling back to "yes".');
            return true;
        }
        var bookable = blockers.length === 0;
        log(depDestCode, depBeginDate, depEndDate, bookable ? 'is' : 'is not', 'bookable without transport.');
        return bookable;
    }).catch(function (error) {
        log.warn('Failed to check if', depDestCode, depBeginDate, depEndDate, 'is bookable without transport. Falling back to "yes".');
        return true;
    });
}

BusSelect.$inject = ['$q', '$scope', 'busService', 'departureService', 'cancelService', 'localizationService'];

_module3.default.component('busSelect', {
    template: require('./busSelect.html'),
    controller: BusSelect,
    bindings: {
        'ngModel': '=', // busStop.Id
        'containerClass': '@',
        'iconClass': '@',
        'depDestCode': '@',
        'depBeginDate': '@',
        'depEndDate': '@',
        'depDestIntClassSets': '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/core/busSelect.js
// module id = 64
// module chunks = 0 2